var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-content',{staticStyle:{"min-height":"1px"}},[_c('router-view')],1),_c('modal-timer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }